<template>
  <div class="img-decypt">
    <van-image
      :src="decyImg"
      class="vanImage swiper-zoom-container"
      fit="cover"
      v-lazy="decyImg"
    >
      <template v-slot:loading>
        <img :src="defaultImg" class="loading" />
      </template>
      <template v-slot:error>
        <img :src="defaultImg" class="loading" />
      </template>
      <slot></slot>
    </van-image>
  </div>
</template>
<script>
import { Image as VanImage } from "vant";
import { imgDecyptApi } from "@/api/app";

export default {
  props: {
    src: {
      type: String,
      required: true,
      default() {
        return "";
      },
    },
    imgCdn: {
      type: String,
      required: true,
    },
  },
  components: {
    [VanImage.name]: VanImage,
  },
  data() {
    return {
      decyImg: "",
      defaultImg: require("@/assets/png/place.png"),
    };
  },
  mounted() {
    this.init();
  },
  methods: {
    init() {
      let src = this.src;
      try {
        let imgApi = this.imgCdn;
        if (imgApi.slice(-1) != "/") {
          imgApi = imgApi + "/";
        }
        if (!imgApi || !src) return;
        src = imgApi + this.src;
        imgDecyptApi(src)
          .then((url) => {
            this.decyImg = url;
          })
          .catch((err) => {
            this.$emit("error");
          });
      } catch (error) {
        this.$emit("error");
        console.log(error);
      }
    },
  },
};
</script>
<style lang="scss" scoped>
/deep/ .van-image__loading {
  overflow: hidden;
  width: 100%;
  height: 100%;
  border-radius: 6px;
}

.splash-loading-img,
.splash-error-img {
  width: 100%;
  height: 100%;
  position: relative;
}

.img-decypt {
  width: 100%;
  height: 100%;
  .vanImage {
    width: 100%;
    height: 100%;
    .loading {
      width: 100%;
      height: 100%;
    }

    /deep/ .van-image__error {
      overflow: hidden;
      width: 100%;
      height: 100%;
      border-radius: 6px;
    }
  }
}
</style>
